function TEMA_LYRA(root) {
    root.style.setProperty('--primary', '#00413c');
    root.style.setProperty('--primary-light', '#373776');
    root.style.setProperty('--secondary', '#94cf1c');
    root.style.setProperty('--success', '#66bb6a');
    root.style.setProperty('--info', '#17a2b8');
    root.style.setProperty('--warning', '#f88342');
    root.style.setProperty('--danger', '#f56c6c');
    root.style.setProperty('--light', '#efefef');
    root.style.setProperty('--dark', '#353b48');
    root.style.setProperty('--black', '#000000');
    root.style.setProperty('--white', '#ffffff');
    root.style.setProperty('--gray', '#808080');
    root.style.setProperty('--gray-light', '#a7a7a7');
    root.style.setProperty('--green', '#008000');
    root.style.setProperty('--red', '#ff0000');
    root.style.setProperty('--dimgray', '#696969');

    /* Cores complementares */
    root.style.setProperty('--secondary-two', '#359138');
    root.style.setProperty('--background-rgba', 'rgba(148, 207, 28, 0.2)');
    root.style.setProperty('--background-danger', '#ffc8c3');
    root.style.setProperty('--font-danger', '#740f0f');
    root.style.setProperty('--hover-danger', '#fa4a3b');
    root.style.setProperty('--background-disabled', '#c1c1c1');
    root.style.setProperty('--text-disabled', '#606266');
    root.style.setProperty('--backgroud-according', '#66bb6a4d');
    root.style.setProperty('--approved-operation', '#94cf1c33');
    root.style.setProperty('--approved-list-operation', '#94cf1c4d');
    root.style.setProperty('--disapproved-operation', '#ffc8c366');
    root.style.setProperty('--nonconforming-report', 'rgba(255, 0, 0, 0.316)');
    root.style.setProperty('--operation-under-review', '#fabc9a');
    root.style.setProperty('--operation-awaiting-approval', '#e9e9e9');
    root.style.setProperty('--failed-operation', '#fb998fb2');
    root.style.setProperty('--block-shadow', 'rgb(0 65 60 / 20%)');
    root.style.setProperty('--background-alert', '#e9bdbd');
    root.style.setProperty('--color-alert', '#ec3232');
    root.style.setProperty('--list-hover-color', '#336763');
    root.style.setProperty('--list-hover-background-color', '#e6ecec');
    root.style.setProperty('--list-background-contrast', '#f3f3f3');
    root.style.setProperty('--link', '#4294ec');
    root.style.setProperty('--error-500', '#dc362e');

    /* Background */
    root.style.setProperty('--default-background-color', '#e1e1e1');
    root.style.setProperty('--selected-background-color', '#fafafa');

    /* Bordas */
    root.style.setProperty('--default-border-color', '#dcdfe6');
    root.style.setProperty('--error-border-color', '#f56c6c');

    /* Fontes */
    root.style.setProperty('--primary-font-color', '#3B3B3B');
    root.style.setProperty('--secondary-font-color', '#909399');
    root.style.setProperty('--disabled-font-color', '#c0c4cc');
    root.style.setProperty('--error-color', '#f56c6c');
    root.style.setProperty('--car-pendente-color', '#e9a82b');
    root.style.setProperty('--car-suspenso-color', '#626466');

    /* Cor Cultura */
    root.style.setProperty('--soja-color', '#ffee58');
    root.style.setProperty('--milho-color', '#9ccc65');
  
    /* Cor Acurácia */
    root.style.setProperty('--acuracia-cinquenta-color', '#D6D951');
    root.style.setProperty('--acuracia-cinquenta-oitenta-color', '#889306');
    root.style.setProperty('--acuracia-oitenta-color', '#63AF01');

    /* Float Boxes */
    root.style.setProperty('--float-box-bg-color', '#ecf0f1');
    root.style.setProperty('--float-box-title-icons-hr-color', '#ddd');
    root.style.setProperty('--float-box-nav-font-color', '#777777');
    root.style.setProperty('--float-box-nav-active-font-color', '#555555');
    root.style.setProperty('--float-box-nav-icons-color', '#9e9e9e');
    root.style.setProperty('--float-box-section-title-color', '#666');
    root.style.setProperty('--float-box-section-hr-color', '#aaa');

    /* Hover e Focus dos botões */
    root.style.setProperty('--color-button-hover', '#00413c');
    root.style.setProperty('--color-button-default-hover', '#e9f0ea');
    root.style.setProperty('--color-button-disabled', '#80a09e');

    /* Tags de informações de tabelas */
    root.style.setProperty('--tag-warning-border', '#faecd8');
    root.style.setProperty('--tag-warning-text', '#e89924');
    root.style.setProperty('--tag-warning-background', '#fdf6ec');

    root.style.setProperty('--tag-success-border', '#e1f3d8');
    root.style.setProperty('--tag-success-text', '#359138');
    root.style.setProperty('--tag-success-background', '#f0f9eb');

    root.style.setProperty('--tag-danger-border', '#fde2e2');
    root.style.setProperty('--tag-danger-text', '#f56c6c');
    root.style.setProperty('--tag-danger-background', '#fde7e7');

    root.style.setProperty('--tag-gray-border', '#d9d9d9');
    root.style.setProperty('--tag-gray-text', '#808080');
    root.style.setProperty('--tag-gray-background', '#efefef');

    root.style.setProperty('--link', '#4294EC');

    /* Custom icons */
    root.style.setProperty('--icon-remove', '#900000');
}

function TEMA_BUNGE(root) {
    root.style.setProperty('--primary', '#043c5a');
    root.style.setProperty('--primary-light', '#373776');
    root.style.setProperty('--secondary', '#3c647d');
    root.style.setProperty('--success', '#66bb6a');
    root.style.setProperty('--info', '#17a2b8');
    root.style.setProperty('--warning', '#f88342');
    root.style.setProperty('--danger', '#f56c6c');
    root.style.setProperty('--light', '#efefef');
    root.style.setProperty('--dark', '#353b48');
    root.style.setProperty('--black', '#000000');
    root.style.setProperty('--white', '#ffffff');
    root.style.setProperty('--gray', '#808080');
    root.style.setProperty('--gray-light', '#a7a7a7');

    /* Cores complementares */
    root.style.setProperty('--secondary-two', '#3c647d');
    root.style.setProperty('--background-rgba', 'rgba(148, 207, 28, 0.2)');
    root.style.setProperty('--background-danger', '#ffc8c3');
    root.style.setProperty('--font-danger', '#740f0f');
    root.style.setProperty('--hover-danger', '#fa4a3b');
    root.style.setProperty('--background-disabled', '#c1c1c1');
    root.style.setProperty('--text-disabled', '#606266');
    root.style.setProperty('--backgroud-according', '#66bb6a4d');
    root.style.setProperty('--approved-operation', '#94cf1c33');
    root.style.setProperty('--approved-list-operation', '#94cf1c4d');
    root.style.setProperty('--disapproved-operation', '#ffc8c366');
    root.style.setProperty('--nonconforming-report', 'rgba(255, 0, 0, 0.316)');
    root.style.setProperty('--operation-under-review', '#fabc9a');
    root.style.setProperty('--operation-awaiting-approval', '#e9e9e9');
    root.style.setProperty('--failed-operation', '#fb998fb2');
    root.style.setProperty('--block-shadow', 'rgb(0 65 60 / 20%)');
    root.style.setProperty('--background-alert', '#e9bdbd');
    root.style.setProperty('--color-alert', '#ec3232');
    root.style.setProperty('--list-hover-color', '#0f6980');
    root.style.setProperty('--list-hover-background-color', '#c2e0f0');
    root.style.setProperty('--list-background-contrast', '#f3f3f3');

    /* Background */
    root.style.setProperty('--default-background-color', '#e1e1e1');
    root.style.setProperty('--selected-background-color', '#fafafa');

    /* Bordas */
    root.style.setProperty('--default-border-color', '#dcdfe6');
    root.style.setProperty('--error-border-color', '#f56c6c');

    /* Fontes */
    root.style.setProperty('--primary-font-color', '#3B3B3B');
    root.style.setProperty('--secondary-font-color', '#aaa5a5');
    root.style.setProperty('--disabled-font-color', '#c0c4cc');
    root.style.setProperty('--error-color', '#f56c6c');
    root.style.setProperty('--car-pendente-color', '#e9a82b');
    root.style.setProperty('--car-suspenso-color', '#626466');

    /* Cor Cultura */
    root.style.setProperty('--soja-color', '#ffee58');
    root.style.setProperty('--milho-color', '#9ccc65');
    
    /* Cor Acurácia */
    root.style.setProperty('--acuracia-cinquenta-color', '#D6D951');
    root.style.setProperty('--acuracia-cinquenta-oitenta-color', '#889306');
    root.style.setProperty('--acuracia-oitenta-color', '#63AF01');

    /* Float Boxes */
    root.style.setProperty('--float-box-bg-color', '#ecf0f1');
    root.style.setProperty('--float-box-title-icons-hr-color', '#ddd');
    root.style.setProperty('--float-box-nav-font-color', '#777777');
    root.style.setProperty('--float-box-nav-active-font-color', '#555555');
    root.style.setProperty('--float-box-nav-icons-color', '#9e9e9e');
    root.style.setProperty('--float-box-section-title-color', '#666');
    root.style.setProperty('--float-box-section-hr-color', '#aaa');

    /* Hover e Focus dos botões */
    root.style.setProperty('--color-button-hover', '#ffffff');
    root.style.setProperty('--color-button-default-hover', '#d1eaee');
    root.style.setProperty('--color-button-disabled', '#b1c7e9');

    /* Tags de informações de tabelas */
    root.style.setProperty('--tag-warning-border', '#faecd8');
    root.style.setProperty('--tag-warning-text', '#e89924');
    root.style.setProperty('--tag-warning-background', '#fdf6ec');

    root.style.setProperty('--tag-success-border', '#e1f3d8');
    root.style.setProperty('--tag-success-text', '#359138');
    root.style.setProperty('--tag-success-background', '#f0f9eb');

    root.style.setProperty('--tag-danger-border', '#fde2e2');
    root.style.setProperty('--tag-danger-text', '#f56c6c');
    root.style.setProperty('--tag-danger-background', '#fde7e7');

    root.style.setProperty('--tag-gray-border', '#d9d9d9');
    root.style.setProperty('--tag-gray-text', '#808080');
    root.style.setProperty('--tag-gray-background', '#efefef');

}

function aplicarTema(tema) {
    const root = document.documentElement;
    this[tema](root);
}

export default { aplicarTema, TEMA_LYRA, TEMA_BUNGE };
